import { Button } from "@/components/ui/button";
import { ArrowRight, Rocket } from "lucide-react";
import HardLink from "@/components/HardLink";

const CTASection = () => {
  return (
    <section className="section-dark relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-glow-gradient opacity-20" />
      <div className="absolute inset-0 grid-pattern opacity-10" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-primary/10 border border-primary/30 animate-pulse-glow">
            <Rocket className="w-10 h-10 text-primary" />
          </div>

          {/* Headline */}
          <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground">
            Klaar voor{" "}
            <span className="text-gradient-green text-glow">Showroom</span>{" "}
            Glans?
          </h2>

          {/* Description */}
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Ontdek ons complete assortiment premium auto en motor detailing producten en geef jouw voertuig de professionele behandeling die het verdient.
          </p>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button variant="hero" size="xl" asChild>
              <HardLink to="/shop">
                Start Nu met Shoppen
                <ArrowRight className="w-5 h-5 ml-2" />
              </HardLink>
            </Button>
          </div>

          {/* Trust */}
          <p className="text-sm text-muted-foreground">
            ✓ Gratis verzending vanaf €50 ✓ 30 dagen retourrecht ✓ Geschikt voor auto & motor ✓ Veilig betalen
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
